import React from 'react';
import {
    withStyles,
    Grid,
    Avatar,
} from '@material-ui/core';
import { withRouter } from 'react-router-dom';

class MNineAvatar extends React.Component {

    renderOne = (avatar) => {
        let { size, radius } = this.props;
        return (
            <Avatar src={avatar} style={{ width: size, height: size, borderRadius: radius }} />
        );
    }

    renderThree = (avatars) => {
        let { size } = this.props;
        let space = 2;
        let wid = (size - (3 * space)) / 2;
        return (
            <Grid container direction='column' justifycontent='center' alignItems='center' style={{ width: size, height: size }}>
                <Avatar src={avatars[0]} style={{ width: wid, height: wid, borderRadius: space }} />
                <Grid container direction='row' justifycontent='center' style={{ marginTop: space }}>
                    <Avatar src={avatars[1]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[2]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
            </Grid>
        );
    }

    renderFour = (avatars) => {
        let { size } = this.props;
        let space = 2;
        let wid = (size - (3 * space)) / 2;
        return (
            <Grid container direction='column' justifycontent='center' alignItems='center' style={{ width: size, height: size }}>
                <Grid container direction='row' justifycontent='center'>
                    <Avatar src={avatars[0]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[1]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
                <Grid container direction='row' justifycontent='center' style={{ marginTop: space }}>
                    <Avatar src={avatars[2]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[3]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
            </Grid>
        );
    }

    renderFive = (avatars) => {
        let { size } = this.props;
        let space = 2;
        let wid = (size - (4 * space)) / 3;
        return (
            <Grid container direction='column' justifycontent='center' alignItems='center' style={{ width: size, height: size }}>
                <Grid container direction='row' justifycontent='center' >
                    <Avatar src={avatars[0]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[1]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
                <Grid container direction='row' justifycontent='center' style={{ marginTop: space }}>
                    <Avatar src={avatars[2]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[3]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                    <Avatar src={avatars[4]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
            </Grid>
        );
    }

    renderSix = (avatars) => {
        let { size } = this.props;
        let space = 2;
        let wid = (size - (4 * space)) / 3;
        return (
            <Grid container direction='column' justifycontent='center' alignItems='center' style={{ width: size, height: size }}>
                <Grid container direction='row' justifycontent='center'>
                    <Avatar src={avatars[0]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[1]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                    <Avatar src={avatars[2]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
                <Grid container direction='row' justifycontent='center' style={{ marginTop: space }}>
                    <Avatar src={avatars[3]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[4]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                    <Avatar src={avatars[5]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
            </Grid>
        );
    }

    renderSeven = (avatars) => {
        let { size } = this.props;
        let space = 2;
        let wid = (size - (4 * space)) / 3;
        return (
            <Grid container direction='column' justifycontent='center' alignItems='center' style={{ width: size, height: size }}>
                <Grid container direction='row' justifycontent='center' alignItems='center'>
                    <Avatar src={avatars[0]} style={{ width: wid, height: wid, borderRadius: space }} />
                </Grid>
                <Grid container direction='row' justifycontent='center' alignItems='center' style={{ marginTop: space }}>
                    <Avatar src={avatars[1]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[2]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                    <Avatar src={avatars[3]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
                <Grid container direction='row' justifycontent='center' alignItems='center' style={{ marginTop: space }}>
                    <Avatar src={avatars[4]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[5]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                    <Avatar src={avatars[6]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
            </Grid>
        );
    }

    renderEight = (avatars) => {
        let { size } = this.props;
        let space = 2;
        let wid = (size - (4 * space)) / 3;
        return (
            <Grid container direction='column' justifycontent='center' alignItems='center' style={{ width: size, height: size }}>
                <Grid container direction='row' justifycontent='center' alignItems='center'>
                    <Avatar src={avatars[0]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[1]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
                <Grid container direction='row' justifycontent='center' alignItems='center' style={{ marginTop: space }}>
                    <Avatar src={avatars[1]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[2]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                    <Avatar src={avatars[3]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
                <Grid container direction='row' justifycontent='center' alignItems='center' style={{ marginTop: space }}>
                    <Avatar src={avatars[4]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[5]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                    <Avatar src={avatars[6]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
            </Grid>
        );
    }

    renderNine = (avatars) => {
        let { size } = this.props;
        let space = 2;
        let wid = (size - (4 * space)) / 3;
        return (
            <Grid container direction='column' justifycontent='center' alignItems='center' style={{ width: size, height: size }}>
                <Grid container direction='row' justifycontent='center' alignItems='center'>
                    <Avatar src={avatars[0]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[1]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                    <Avatar src={avatars[3]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
                <Grid container direction='row' justifycontent='center' alignItems='center' style={{ marginTop: space }}>
                    <Avatar src={avatars[1]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[2]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                    <Avatar src={avatars[3]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
                <Grid container direction='row' justifycontent='center' alignItems='center' style={{ marginTop: space }}>
                    <Avatar src={avatars[4]} style={{ width: wid, height: wid, borderRadius: space }} />
                    <Avatar src={avatars[5]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                    <Avatar src={avatars[6]} style={{ width: wid, height: wid, borderRadius: space, marginLeft: space }} />
                </Grid>
            </Grid>
        );
    }



    render() {
        const { imgs, classes } = this.props
        if (!imgs) {
            return (
                <div></div>
            );
        }
        return (
            <div className='chatAvatar'>
                <Grid className={classes.root} >
                    {(imgs.length == 1 || imgs.length == 2) && this.renderOne(imgs[0])}
                    {(imgs.length == 3) && this.renderThree(imgs)}
                    {(imgs.length == 4) && this.renderFour(imgs)}
                    {(imgs.length == 5) && this.renderFive(imgs)}
                    {(imgs.length == 6) && this.renderSix(imgs)}
                    {(imgs.length == 7) && this.renderSeven(imgs)}
                    {(imgs.length == 8) && this.renderEight(imgs)}
                    {(imgs.length == 9) && this.renderNine(imgs)}
                </Grid>
            </div>
        );
    }
}


export default withRouter(withStyles((theme) => ({
    root: {
        backgroundColor: '#E2E2E2',
        borderRadius: 50,
        overflow:'hidden'
    }
}))(MNineAvatar));